module.exports = function (lang) {
    var _this = this;
    this.lang = lang;
    this.tran = function (text) {
        if (tranTxt[_this.lang] && tranTxt[_this.lang][text]) {
            return tranTxt[_this.lang][text];
        } else {
            return text;
        }
    };
};
var tranTxt = {
    'ru': {
        'LinePlayer is loading': 'LinePlayer загружается',
        'About LinePlayer': 'О LinePlayer',
        'This video fails to load': 'Ошибка загрузки видео',
        'Full screen': 'Во весь экран',
        'Screenshot': 'Скриншот',
        'Volume': 'Громкость',
        'Live': 'В эфире',
        'Play': 'Возпроизвести',
        'Pause': 'Пауза',
        'Prev': 'Предыдущее',
        'Next': 'Следующее',
        'Quality change': 'Сменить качество видео'
    }
};